<!---Banner section-->
<div class="collab-banner sticky-header-banner banner-sec">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <div class="mx-auto whats-new-label transparent-bg">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph">
                        {{'researchAndAnalysis.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mx-auto mw-900">{{'researchAndAnalysis.banner.title' | translate}}</h1>
                <p class="paragraph-global-text mw-850">{{'researchAndAnalysis.banner.description' | translate}}</p>
                <div class="mt-5 mb-5 mx-auto button-container align-items-start">
                    <form [formGroup]="emailValidations" (ngSubmit)="onSubmit()" class="input-form btn p-0">
                        <input type="text" id="workmail" (input)="domainError = false" class="form-control banner-input border-purple-700" placeholder="Enter your work email" formControlName="emailId" required>            
                    </form>
                    <a class="save-btn cfa btn" (click)="onSubmit()">
                        {{'researchAndAnalysis.banner.btnText' | translate}}    
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast position="bottom-left"></p-toast>

<!-- Hire Designers -->
<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{'researchAndAnalysis.services.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph d-block mb-0">{{'researchAndAnalysis.services.description' | translate}}</p>
            <p class="paragraph-global-text sub-head-paragraph mw-700 mb-0 mt-3">{{'researchAndAnalysis.services.description2' | translate}}</p>
        </div>
        <div class="row">
            <!-- Sec -1-->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-column-increasing icon-primary-color"><line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section1.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section1.subDescription' | translate}}</p>
                    <p class="paragraph-global-text">{{'researchAndAnalysis.services.section1.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section1.fee' | translate}}</h6>
                </div>
            </div>
            <!--Sec -2 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database icon-primary-color"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section2.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section2.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section2.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section2.fee' | translate}}</h6>
                </div>
            </div>
            <!-- Sec -3 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-microscope icon-primary-color"><path d="M6 18h8"/><path d="M3 22h18"/><path d="M14 22a7 7 0 1 0 0-14h-1"/><path d="M9 14h2"/><path d="M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"/><path d="M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section3.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section3.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section3.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section3.fee' | translate}}</h6>
                </div>
            </div>
            <!-- Sec -4 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign icon-primary-color"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section4.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section4.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section4.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section4.fee' | translate}}</h6>
                </div>
            </div>

            <!-- Sec -5 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard-list icon-primary-color"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section5.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section5.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section5.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section5.fee' | translate}}</h6>
                </div>
            </div>

            <!-- Sec -6 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-round icon-primary-color"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section6.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section6.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section6.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section6.fee' | translate}}</h6>
                </div>
            </div>

            <!-- Sec -7 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text icon-primary-color"><path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/><path d="M6 12h2"/><path d="M6 8h2"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section7.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section7.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section7.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section7.fee' | translate}}</h6>
                </div>
            </div>

            <!-- Sec -8 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye icon-primary-color"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>
                    </div>
                    <h4 class="heading-three mb-1">{{'researchAndAnalysis.services.section8.title' | translate}}</h4>
                    <p class="paragraph-global-text f-14">{{'researchAndAnalysis.services.section8.subDescription' | translate}}</p>
                    <p class="paragraph-global-text mb-3">{{'researchAndAnalysis.services.section8.description' | translate}}</p>
                    <h6 class="heading-four mb-0 primary-color">{{'researchAndAnalysis.services.section8.fee' | translate}}</h6>
                </div>
            </div>

        </div>
        
    </div>
</div>

<!--Outsourcing to Specialized Agencies--->
<div class="sec-padding background-secondary">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{'researchAndAnalysis.agencies.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph d-block mb-0">{{'researchAndAnalysis.agencies.description' | translate}}</p>
            <p class="paragraph-global-text sub-head-paragraph mw-700 mb-0 mt-3">{{'researchAndAnalysis.agencies.description2' | translate}}</p>
        </div>
        <div class="row">
            <!-- Sec - 1 -->
            <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards lft-img-card">
                    <div class="rounded-img-bg w-fit mr-4 p-3 h-fit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database icon-primary-color"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/></svg>
                     </div>
                    <div>
                        <h4 class="heading-three mb-1">{{'researchAndAnalysis.agencies.section1.title' | translate}}</h4>
                        <p class="paragraph-global-text">{{'researchAndAnalysis.agencies.section1.description' | translate}}</p>
                        <span class="heading-four active mt-4 primary-color">{{'researchAndAnalysis.agencies.section1.fee' | translate}}</span>
                    </div>
                </div>
            </div>
            <!--sec-2 -->
            <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards lft-img-card">
                    <div class="rounded-img-bg w-fit mr-4 p-3 h-fit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard-list icon-primary-color"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
                     </div>
                    <div>
                        <h4 class="heading-three mb-1">{{'researchAndAnalysis.agencies.section2.title' | translate}}</h4>
                        <p class="paragraph-global-text">{{'researchAndAnalysis.agencies.section2.description' | translate}}</p>
                        <span class="heading-four active mt-4 primary-color">{{'researchAndAnalysis.agencies.section2.fee' | translate}}</span>
                    </div>
                </div>
            </div>
            <!--sec-3 -->
            <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards lft-img-card">
                    <div class="rounded-img-bg w-fit mr-4 p-3 h-fit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text icon-primary-color"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
                     </div>
                    <div>
                        <h4 class="heading-three mb-1">{{'researchAndAnalysis.agencies.section3.title' | translate}}</h4>
                        <p class="paragraph-global-text">{{'researchAndAnalysis.agencies.section3.description' | translate}}</p>
                        <span class="heading-four active mt-4 primary-color">{{'researchAndAnalysis.agencies.section3.fee' | translate}}</span>
                    </div>
                </div>
            </div>
            <!--- sec-4 -->
            <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards lft-img-card">
                    <div class="rounded-img-bg w-fit mr-4 p-3 h-fit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search icon-primary-color"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                     </div>
                    <div>
                        <h4 class="heading-three mb-1">{{'researchAndAnalysis.agencies.section4.title' | translate}}</h4>
                       <p class="paragraph-global-text">{{'researchAndAnalysis.agencies.section4.description' | translate}}</p>
                       <span class="heading-four active mt-4 primary-color">{{'researchAndAnalysis.agencies.section4.fee' | translate}}</span>
                    </div>
                </div>
            </div>
            <!--- sec-5 -->
            <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards lft-img-card">
                    <div class="rounded-img-bg w-fit mr-4 p-3 h-fit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-text-search icon-primary-color"><path d="M21 6H3"/><path d="M10 12H3"/><path d="M10 18H3"/><circle cx="17" cy="15" r="3"/><path d="m21 19-1.9-1.9"/></svg>
                     </div>
                    <div>
                        <h4 class="heading-three mb-1">{{'researchAndAnalysis.agencies.section5.title' | translate}}</h4>
                        <p class="paragraph-global-text">{{'researchAndAnalysis.agencies.section5.description' | translate}}</p>
                        <span class="heading-four active mt-4 primary-color">{{'researchAndAnalysis.agencies.section5.fee' | translate}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container mt-5 pt-3">
            <a class="save-btn btn" routerLink="/en/book-demo">
                {{'researchAndAnalysis.agencies.btn' | translate}}
            </a>
        </div>
    </div>
</div>

<!--Why ask amy--->
<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{'researchAndAnalysis.whyChooseAmy.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-700 mb-0">{{'researchAndAnalysis.whyChooseAmy.description' | translate}}</p>
        </div>
        <div class="row">
            <!-- Sec-1 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-scale icon-primary-color icon-primary-color"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>
                     </div>
                     <h4 class="heading-three mb-1">{{'researchAndAnalysis.whyChooseAmy.section1.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'researchAndAnalysis.whyChooseAmy.section1.description' | translate}}</p>
                </div>
            </div>
            <!-- sec-2 -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-piggy-bank icon-primary-color icon-primary-color"><path d="M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z"/><path d="M2 9v1c0 1.1.9 2 2 2h1"/><path d="M16 11h.01"/></svg>
                     </div>
                     <h4 class="heading-three mb-1">{{'researchAndAnalysis.whyChooseAmy.section2.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'researchAndAnalysis.whyChooseAmy.section2.description' | translate}}</p>
                </div>
            </div>
            <!-- sec-3-->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe icon-primary-color"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>
                     </div>
                     <h4 class="heading-three mb-1">{{'researchAndAnalysis.whyChooseAmy.section3.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'researchAndAnalysis.whyChooseAmy.section3.description' | translate}}</p>
                </div>
            </div>
           
        </div>
    </div>
</div>

<!---testinomials-->
<div class="sec-padding background-secondary">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"researchAndAnalysis.testimonials.title" | translate}}</h2>
        </div>
        <div class="mw-900 mx-auto">
            <div class="row">
                <!--sec-1-->
                <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                    <div class="card why-amy-cards">
                        <p class="paragraph-global-text" style="font-style: italic;"> {{"researchAndAnalysis.testimonials.section1.title" | translate}}</p>
                        <h6 class="heading-four mb-0"> {{"researchAndAnalysis.testimonials.section1.description" | translate}}</h6>
                    </div>
                 </div>
                  <!--sec-2-->
                 <div class="col-lg-6 col-md-6 col-sm-12 pt-4">
                    <div class="card why-amy-cards">
                        <p class="paragraph-global-text" style="font-style: italic;"> {{"researchAndAnalysis.testimonials.section2.title" | translate}}</p>
                        <h6 class="heading-four mb-0"> {{"researchAndAnalysis.testimonials.section2.description" | translate}}</h6>
                    </div>
                 </div>
            </div>
        </div>       
    </div>
</div>


 <!-- faqs  -->
 <div class="sec-padding mcqs-sec">
    <div class="container">
      <div class="text-center mb-5 pb-4">
        <div class="content-sec">
          <h1 class="heading-one">
            {{'researchAndAnalysis.faq.title' | translate}}
          </h1>
        </div>
      </div>
  
      <div class="accordion mw-800 mx-auto">
        <div class="expansion-panel-group">
          <div
            *ngFor="let panel of faqAccordion; let i = index"
            class="expansion-panel"
            [class.active]="expandedIndex === i"
          >
            <!-- Panel Header -->
            <div class="expansion-panel-header" (click)="togglePanel(i)">
              <span class="heading-three" [class.active]="expandedIndex === i">{{ panel.question}}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.filter-blue]="expandedIndex === i"
                [class.expanded]="expandedIndex === i"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
        
            <!-- Panel Content -->
            <div class="expansion-panel-content"
              [style.maxHeight]="expandedIndex === i ? contentHeights[i] + 'px' : '0px'">
              <div #contentWrapper class="content-wrapper" style="gap: 25px;">
               <ng-container>
                  <div class="card why-amy-cards transparent-bg mt-1 mb-3">
                    <p class="paragraph-global-text mb-0">{{panel.ans}}</p>
                  </div>
               </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    
      <!-- cfa  -->
      <div class="sec-padding cfa-sec position-relative">    
          <div class="cfa-grid"></div>
        <div class="container z-index">
            <div class="sec-title text-center">            
                <h2 class="heading-one text-white mx-auto">{{'researchAndAnalysis.cta.title' | translate}}</h2>
                <p class="paragraph-global-text sub-head-paragraph mw-700 text-white">{{'researchAndAnalysis.cta.description' | translate}}</p>
      
                <div class="button-container mt-5 ">
                    <a class="save-btn cfa btn" [routerLink]="['/en/book-demo']" target="_blank">
                        {{'researchAndAnalysis.cta.btnText' | translate}}
                    </a>
                </div>
            </div>
        </div>
      </div>